

/// <reference path="ReportItem.ts" />

// Generated class ReportListItem_ManagedObject

class ReportListItem_ManagedObject extends ReportItem
{
}
